/**
 * Body measurement interactive visual — Update 2.0 ONLY.
 * Isolated API: window.StAgniBodyMeasurementVisualD20
 * - Waist zoom; all 3 lines visible
 * - Click/touch only (no hover)
 * - No looping animation
 * - Size selection bound to table headers / cells
 * - Active size column underlined + black; inactive grey
 * - Active type line stronger black; inactive lines grey
 */
(function (window, document) {
  'use strict';

  var lockedView = {
    zoom: 1,
    x: 0,
    y: 0,
    originX: 50,
    originY: 50
  };

  /* Line coordinates are in the original 1000×1400 drawing space.
     The visible window is viewBox 260 210 700 980 so the figure sits higher and centred.
     Labels sit to the right of each line. */
  var measurementRegions = {
    bust: {
      line: { y: 480, x1: 362, x2: 695, curve: 0, labelX: 745, labelY: 492, label: 'Bust' }
    },
    waist: {
      line: { y: 710, x1: 411, x2: 645, curve: 0, labelX: 695, labelY: 722, label: 'Waist' }
    },
    hip: {
      line: { y: 880, x1: 374, x2: 683, curve: 0, labelX: 733, labelY: 892, label: 'Hip' }
    }
  };

  var TYPE_ORDER = ['bust', 'waist', 'hip'];
  var HOW_BY_TYPE = {
    bust: 'Around the fullest part of the bust, keeping the tape level and relaxed.',
    waist: 'Around the narrowest part of the waist, usually just above the navel.',
    hip: 'Around the fullest part of the hips, standing with your feet together.'
  };
  var SIZE_OPTION_RE = /size|taille|größe|gr\u00f6\u00dfe|tamanho|tama\u00f1o|koko|\u30b5\u30a4\u30ba/i;
  var COLOR_ACTIVE = '#000000';
  var COLOR_INACTIVE = '#c4c4c4';
  var STROKE_ACTIVE = 0.85;
  var STROKE_INACTIVE = 0.85;
  var initialized = new WeakSet();

  function getProductData() {
    var el = document.querySelector('[data-product-json]');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function getSizeOptionIndex(product) {
    if (!product || !product.options) return 0;
    for (var i = 0; i < product.options.length; i++) {
      if (SIZE_OPTION_RE.test(product.options[i])) return i;
    }
    return 0;
  }

  function variantSize(variant, product) {
    if (!variant || !product) return null;
    var idx = getSizeOptionIndex(product);
    return variant['option' + (idx + 1)] || variant.option1;
  }

  function getPdpSize() {
    var data = getProductData();
    if (data && data.product && data.selected_variant_id) {
      var variant = data.product.variants.find(function (v) {
        return v.id === data.selected_variant_id;
      });
      var size = variantSize(variant, data.product);
      if (size) return normalizeSize(size);
    }
    var checked = document.querySelector('.ProductForm__Option .SizeSwatch__Radio:checked');
    return checked ? normalizeSize(checked.value) : null;
  }

  function normalizeSize(label) {
    return String(label || '').trim().toUpperCase();
  }

  function parseTableData(table) {
    var headers = [];
    var ths = table.querySelectorAll('thead th');
    for (var i = 1; i < ths.length; i++) {
      headers.push(normalizeSize(ths[i].textContent.replace(/\s*\((?:cm|in)\)\s*$/i, '')));
    }

    var measurements = { bust: {}, waist: {}, hip: {} };
    var rows = table.querySelectorAll('tbody tr');
    rows.forEach(function (row) {
      var cells = row.querySelectorAll('td');
      if (!cells.length) return;
      var key = String(cells[0].textContent).trim().toLowerCase();
      if (!measurements[key]) return;
      for (var c = 1; c < cells.length; c++) {
        var size = headers[c - 1];
        if (!size) continue;
        var cm = cells[c].getAttribute('data-cm');
        if (cm == null) {
          var parsed = parseFloat(String(cells[c].textContent).replace(',', '.'));
          if (!isNaN(parsed)) cm = String(parsed);
        }
        if (cm != null) measurements[key][size] = parseFloat(cm);
      }
    });
    return { sizes: headers, measurements: measurements };
  }

  function formatValueShort(cm, unit) {
    if (cm == null || isNaN(cm)) return '—';
    if (unit === 'in') {
      var inches = cm / 2.54;
      var s = inches.toFixed(1);
      if (s.endsWith('.0')) s = s.slice(0, -2);
      return s + 'in';
    }
    var out = parseFloat(cm).toFixed(1);
    if (out.endsWith('.0')) out = out.slice(0, -2);
    return out + 'cm';
  }

  function getMeasurementValue(data, type, size) {
    if (!data || !data.measurements || !data.measurements[type]) return null;
    return data.measurements[type][size];
  }

  function getActiveUnit(grid) {
    var active = grid.querySelector('.unit-link.is-active');
    return active && active.getAttribute('data-unit') === 'in' ? 'in' : 'cm';
  }

  function clearSvg(svg) {
    if (!svg) return;
    while (svg.firstChild) svg.removeChild(svg.firstChild);
  }

  function applyView(viewport, view) {
    if (!viewport || !view) return;
    viewport.style.transformOrigin = view.originX + '% ' + view.originY + '%';
    viewport.style.transform = 'scale(' + view.zoom + ') translate(' + view.x + '%, ' + view.y + '%)';
  }

  function BodyMeasurementVisualD20(grid) {
    this.grid = grid;
    this.panel = grid.closest('[id^="tab-body-measurements"]');
    this.root = this.panel
      ? this.panel.querySelector('[data-body-measurement-visual-d20]')
      : grid.querySelector('[data-body-measurement-visual-d20]');
    this.table = grid.querySelector('.body-measurements-table');
    this.viewport = this.root && this.root.querySelector('[data-bm-viewport]');
    this.svg = this.root && this.root.querySelector('[data-bm-svg]');
    this.howtoEl = this.root && this.root.querySelector('[data-bm-howto]');
    this.srValueEl = this.root && this.root.querySelector('[data-bm-sr-value]');
    this.state = {
      type: 'bust',
      size: null,
      unit: 'cm',
      data: null
    };
  }

  BodyMeasurementVisualD20.prototype.init = function () {
    if (!this.root || !this.table) return;
    if (initialized.has(this.grid)) return;
    initialized.add(this.grid);

    this.state.data = parseTableData(this.table);
    this.state.unit = getActiveUnit(this.grid);
    this.state.size = this.resolveInitialSize();
    this.state.type = 'bust';

    this.decorateTable();
    this.bindEvents();
    this.root.removeAttribute('hidden');
    this.syncTableActive();
    applyView(this.viewport, lockedView);
    this.render();
  };

  BodyMeasurementVisualD20.prototype.resolveInitialSize = function () {
    var pdp = getPdpSize();
    if (pdp && this.state.data.sizes.indexOf(pdp) !== -1) return pdp;
    if (this.state.data.sizes.indexOf('M') !== -1) return 'M';
    return this.state.data.sizes[0] || 'M';
  };

  BodyMeasurementVisualD20.prototype.decorateTable = function () {
    var self = this;
    var headers = this.state.data.sizes;
    var ths = this.table.querySelectorAll('thead th');
    for (var i = 1; i < ths.length; i++) {
      var size = headers[i - 1];
      if (!size) continue;
      ths[i].classList.add('bm-table-size-h');
      ths[i].setAttribute('data-bm-table-size', size);
      ths[i].setAttribute('role', 'button');
      ths[i].setAttribute('tabindex', '0');
    }

    this.table.querySelectorAll('tbody tr').forEach(function (row) {
      var cells = row.querySelectorAll('td');
      if (!cells.length) return;
      var type = String(cells[0].textContent).trim().toLowerCase();
      if (TYPE_ORDER.indexOf(type) === -1) return;
      cells[0].classList.add('bm-table-type-label');
      cells[0].setAttribute('data-bm-table-type', type);
      cells[0].setAttribute('role', 'button');
      cells[0].setAttribute('tabindex', '0');
      for (var c = 1; c < cells.length; c++) {
        var size = headers[c - 1];
        if (!size) continue;
        cells[c].classList.add('bm-table-size-cell');
        cells[c].setAttribute('data-bm-table-size', size);
        cells[c].setAttribute('data-bm-table-type', type);
        cells[c].setAttribute('role', 'button');
        cells[c].setAttribute('tabindex', '0');
      }
    });
  };

  BodyMeasurementVisualD20.prototype.bindEvents = function () {
    var self = this;

    this.table.addEventListener('click', function (e) {
      var cell = e.target.closest('[data-bm-table-size], [data-bm-table-type]');
      if (!cell || !self.table.contains(cell)) return;
      e.preventDefault();
      var size = cell.getAttribute('data-bm-table-size');
      var type = cell.getAttribute('data-bm-table-type');
      if (type && measurementRegions[type]) self.selectType(type, true);
      if (size) self.setSize(size, true);
      self.render();
    });

    this.table.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var cell = e.target.closest('[data-bm-table-size], [data-bm-table-type]');
      if (!cell || !self.table.contains(cell)) return;
      e.preventDefault();
      cell.click();
    });

    if (this.svg) {
      this.svg.addEventListener('click', function (e) {
        var node = e.target.closest('[data-bm-line], [data-bm-line-label]');
        if (!node || !self.svg.contains(node)) return;
        e.preventDefault();
        e.stopPropagation();
        var type = node.getAttribute('data-bm-line') || node.getAttribute('data-bm-line-label');
        if (type && measurementRegions[type]) self.selectType(type);
      });
    }

    this.grid.addEventListener('bodyMeasurements:unitChanged', function (e) {
      if (!e.detail) return;
      self.state.unit = e.detail.unit === 'in' ? 'in' : 'cm';
      self.render();
    });

    document.addEventListener('variant:changed', function () {
      if (!self.grid.closest('.sizeguide-prototype-panel.is-active')) return;
      var pdp = getPdpSize();
      if (pdp) self.setSize(pdp);
    });
  };

  BodyMeasurementVisualD20.prototype.selectType = function (type, skipRender) {
    if (!measurementRegions[type]) return;
    this.state.type = type;
    this.syncTableActive();
    this.updateSr();
    if (!skipRender) this.render();
  };

  BodyMeasurementVisualD20.prototype.setSize = function (size, skipRender) {
    size = normalizeSize(size);
    if (this.state.data.sizes.indexOf(size) === -1) return;
    this.state.size = size;
    this.syncTableActive();
    this.updateSr();
    if (!skipRender) this.render();
  };

  BodyMeasurementVisualD20.prototype.syncTableActive = function () {
    var size = this.state.size;
    var type = this.state.type;
    var sizeIndex = this.state.data.sizes.indexOf(size);

    this.table.querySelectorAll('[data-bm-table-size]').forEach(function (el) {
      var active = el.getAttribute('data-bm-table-size') === size;
      el.classList.toggle('is-size-active', active);
    });

    this.table.querySelectorAll('[data-bm-table-type]').forEach(function (el) {
      var active = el.getAttribute('data-bm-table-type') === type;
      el.classList.toggle('is-type-active', active);
    });

    // Column index classes for full-column greying (header + body cells)
    var ths = this.table.querySelectorAll('thead th');
    var rows = this.table.querySelectorAll('tbody tr');
    for (var i = 1; i < ths.length; i++) {
      var colActive = i - 1 === sizeIndex;
      ths[i].classList.toggle('is-col-active', colActive);
      ths[i].classList.toggle('is-col-inactive', !colActive);
    }
    rows.forEach(function (row) {
      var cells = row.querySelectorAll('td');
      var rowType = cells[0] ? String(cells[0].textContent).trim().toLowerCase() : '';
      var rowActive = TYPE_ORDER.indexOf(rowType) !== -1 && rowType === type;
      if (cells[0]) {
        cells[0].classList.toggle('is-row-active', rowActive);
        cells[0].classList.toggle('is-row-inactive', TYPE_ORDER.indexOf(rowType) !== -1 && !rowActive);
      }
      for (var c = 1; c < cells.length; c++) {
        var colActive = c - 1 === sizeIndex;
        cells[c].classList.toggle('is-col-active', colActive);
        cells[c].classList.toggle('is-col-inactive', !colActive);
      }
    });
  };

  BodyMeasurementVisualD20.prototype.updateSr = function () {
    var type = this.state.type;
    var cm = getMeasurementValue(this.state.data, type, this.state.size);
    var valueText = formatValueShort(cm, this.state.unit);
    var typeLabel = type.charAt(0).toUpperCase() + type.slice(1);
    if (this.srValueEl) {
      this.srValueEl.textContent = typeLabel + ', size ' + this.state.size + ', ' + valueText;
    }
  };

  BodyMeasurementVisualD20.prototype.updateHowTo = function () {
    if (!this.howtoEl) return;
    var type = this.state.type;
    var typeLabel = type.charAt(0).toUpperCase() + type.slice(1);
    var how = HOW_BY_TYPE[type] || '';
    this.howtoEl.innerHTML =
      '<b>How to measure your ' + typeLabel + '</b>' + how;
  };

  BodyMeasurementVisualD20.prototype.drawAllLines = function () {
    var self = this;
    var svg = this.svg;
    var activeType = this.state.type;
    var ns = 'http://www.w3.org/2000/svg';

    clearSvg(svg);
    applyView(this.viewport, lockedView);

    TYPE_ORDER.forEach(function (key) {
      var region = measurementRegions[key];
      if (!region || !region.line) return;
      var active = key === activeType;
      var l = region.line;
      var y = l.y;
      var x1 = l.x1;
      var x2 = l.x2;
      var cx = (x1 + x2) / 2;
      var cy = y + (l.curve || 0);
      var labelX = l.labelX != null ? l.labelX : x2 + 20;
      var cm = getMeasurementValue(self.state.data, key, self.state.size);
      var labelText = formatValueShort(cm, self.state.unit);

      var path = document.createElementNS(ns, 'path');
      path.setAttribute('class', 'bm-measure-path' + (active ? ' is-active' : ' is-inactive'));
      path.setAttribute('data-bm-line', key);
      path.setAttribute('d', 'M ' + x1 + ' ' + y + ' Q ' + cx + ' ' + cy + ' ' + x2 + ' ' + y);
      path.setAttribute('stroke', active ? COLOR_ACTIVE : COLOR_INACTIVE);
      path.setAttribute('stroke-width', active ? String(STROKE_ACTIVE) : String(STROKE_INACTIVE));
      var hit = path.cloneNode(false);
      hit.setAttribute('class', 'bm-measure-hit');
      hit.setAttribute('stroke', 'transparent');
      hit.setAttribute('stroke-width', '8');
      svg.appendChild(hit);
      svg.appendChild(path);

      var text = document.createElementNS(ns, 'text');
      text.setAttribute('class', 'bm-measure-value' + (active ? ' is-active' : ' is-inactive'));
      text.setAttribute('data-bm-line-label', key);
      text.setAttribute('x', labelX);
      text.setAttribute('y', y);
      text.setAttribute('dominant-baseline', 'central');
      text.setAttribute('fill', active ? COLOR_ACTIVE : COLOR_INACTIVE);
      text.textContent = labelText;
      svg.appendChild(text);
    });

    var vb = svg.viewBox && svg.viewBox.baseVal;
    var rect = svg.getBoundingClientRect();
    if (vb && vb.height && rect.height > 1) {
      var sample = this.table && this.table.querySelector('td, th');
      var screenPx = 13;
      if (sample) {
        var parsed = parseFloat(window.getComputedStyle(sample).fontSize);
        if (parsed) screenPx = parsed;
      }
      var userPx = screenPx * (vb.height / rect.height);
      Array.prototype.forEach.call(svg.querySelectorAll('.bm-measure-value'), function (label) {
        label.style.fontSize = userPx + 'px';
      });
    }
  };

  BodyMeasurementVisualD20.prototype.render = function () {
    this.drawAllLines();
    this.syncTableActive();
    this.updateHowTo();
    this.updateSr();
  };

  window.StAgniBodyMeasurementVisualD20 = {
    lockedView: lockedView,
    measurementRegions: measurementRegions,
    init: function (gridEl) {
      if (!gridEl) return;
      var instance = new BodyMeasurementVisualD20(gridEl);
      instance.init();
      return instance;
    },
    refresh: function (gridEl) {
      if (!gridEl || !initialized.has(gridEl)) return;
      initialized.delete(gridEl);
      window.StAgniBodyMeasurementVisualD20.init(gridEl);
    }
  };
})(window, document);
